export default "__VITE_ASSET__59251dd0__"